import { useState, createContext } from "react";

const ProjectContext = createContext();

const ProjectProvider = ({ children }) => {
  const [project, setProject] = useState("");
  const [projectData, setProjectData] = useState("");

  return (
    <ProjectContext.Provider
      value={{ project, setProject, projectData, setProjectData }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export default ProjectProvider;

const ProjectConsumer = ProjectProvider.Consumer;
export { ProjectConsumer, ProjectContext };
